/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc メッセージ送信フォーム
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-send-message-form">

  <el-main class="main-area">
    <el-form ref="fastchatSendMessageForm" :model="fastchatSendMessage" :rules="rules" v-show="isShowSendTextMessageInputForm">
      <el-form-item prop="messageText">
        <el-autocomplete ref="suggestAutocomplete" class="inline-input" style="width:100%; visibility: hidden; position: absolute;" popper-class="fhsuggest-popper" :fetch-suggestions="suggestFetchFunc" @select="suggestAutocompleteSelectHandler"></el-autocomplete>
        <el-input ref="sendMessageTextArea" class="send-message-textarea" type="textarea" resize="none" @keyup.enter.ctrl.native="send" :readonly="!permissionSendMessageInput" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('こちらに質問内容を入力してください')"
          v-model="fastchatSendMessage.messageText"></el-input>
      </el-form-item>
    </el-form>
    <div class="upload-send-file-wrapper" v-show="isShowUploadedSendFile">
      <el-upload ref="sendFileUploader" style="display: none;" :accept="sendFileUploaderAccept" :action="sendFileUploaderAction" :headers="{'X-XSRF-TOKEN':xsrfTocken}" :before-upload="uploadSendFileBeforeUploadHandler" :on-success="uploadSendFileSuccessHandler" :on-error="uploadSendFileErrorHandler" :limit="1">
        <el-button ref="uploadSendFileButton"></el-button>
      </el-upload>
      <el-container style="height: 100%">
        <el-aside width="auto" style="align-items: center; display: flex;">
          <div class="uploaded-send-file-img-wrapper" v-show="isShowImagePreview">
            <img class="uploaded-send-file-img" :src="uploadedSendFileUrl" :title="uploadedSendFileName" />
          </div>
        </el-aside>
        <el-main class="uploaded-send-file-name-wrapper" style="align-items: center; display: flex;">
          <div class="uploaded-send-file-name" :title="uploadedSendFileName">{{uploadedSendFileName}}</div>
        </el-main>
        <el-aside width="auto" style="align-items: center; display: flex;">
          <el-button class="cancel-send-file-button" icon="el-icon-close" @click="cancelSendFile"></el-button>
        </el-aside>
      </el-container>
    </div>
  </el-main>

  <el-aside class="send-message-button-wrapper" width="auto">
    <el-button class="send-message-button" type="primary" :disabled="!permissionSend" @click="send">{{$t('送信')}}</el-button>
    <el-dropdown @command="doMenu" v-show="isShowMenuButton" trigger="click">
      <el-button class="send-menu-button" type="primary" @mousedown.prevent="" :disabled="!permissionMenu">･･･</el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="uploadSendImageFile" v-show="$config.sendImageFileFlg">{{$t('画像ファイルを選択')}}</el-dropdown-item>
        <el-dropdown-item command="uploadSendVideoFile" v-show="$config.sendVideoFileFlg">{{$t('動画ファイルを選択')}}</el-dropdown-item>
        <el-dropdown-item command="uploadSendFile" v-show="$config.sendFileFlg">{{$t('ファイルを選択')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-aside>

</el-container>
</template>

<script>
import {
  Autocomplete,
  Input,
  Button,
  Container,
  Aside,
  Main,
  Form,
  FormItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Upload
} from 'element-ui'
import ValidateUtil from '@/utils/ValidateUtil'
import DialogUtil from '@/utils/DialogUtil'
import StringUtil from '@/utils/StringUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import MessageInfoConst from '@/constants/MessageInfoConst'
import VueCookie from 'vue-cookie'

export default {
  name: 'FcSendMessageForm',
  components: {
    'el-autocomplete': Autocomplete,
    'el-input': Input,
    'el-button': Button,
    'el-container': Container,
    'el-aside': Aside,
    'el-main': Main,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
    'el-upload': Upload
  },
  props: ['disabled', 'requesting', 'receptionMode', 'useSuggestion'],
  data() {
    return {
      fastchatSendMessage: {
        messageText: ''
      },
      rules: {
        messageText: [{
          max: this.$root.$config.sendMessageMaxLength,
          message: this.$t('{sendMessageMaxLength} 文字以内にしてください', {
            sendMessageMaxLength: this.$root.$config.sendMessageMaxLength
          }),
          trigger: 'change'
        }, {
          validator: this.validateWrongPatternList,
          trigger: 'change'
        }]
      },
      validFastchatSendMessageForm: false,
      suggestList_: [],
      determiningSuggestTargetKeyword: false,
      sendMessageType: MessageInfoConst.MESSAGE_TYPE_TEXT,
      uploadingSendFile: false,
      sendFileUploaderAccept: '',
      sendFileUploaderAction: '',
      uploadedSendFileUrl: '',
      uploadedSendFileName: '',
      uploadedSendFileContentId: null
    }
  },
  watch: {
    'fastchatSendMessage.messageText'(newVal) {
      if (newVal != null && newVal.length !== 0) {
        this.$emit('messageTyping', null)
      }
      if (!this.determiningSuggestTargetKeyword) {
        this.determiningSuggestTargetKeyword = true
        setTimeout(_ => {
          this.determiningSuggestTargetKeyword = false
          if (this.permissionSuggestion) {
            this.$emit('suggestion', this.fastchatSendMessage.messageText.trim())
          } else if (this.$refs['suggestAutocomplete'].suggestionVisible) {
            this.$refs['suggestAutocomplete'].close()
          }
        }, this.$root.$config.suggestIntarval)
      }
    }
  },
  mounted() {
    setTimeout(_ => {
      this.validateFastchatSendMessageForm((valid) => {
        this.validFastchatSendMessageForm = valid
      })
      this.$refs['sendMessageTextArea'].resizeTextarea()
    }, 100)
  },
  updated() {
    this.validateFastchatSendMessageForm((valid) => {
      this.validFastchatSendMessageForm = valid
    })
  },
  computed: {
    /**
     * 送信メッセージの入力が可能か
     * @return {Boolean}
     */
    permissionSendMessageInput() {
      return !this.disabled && !this.requesting && !this.uploadingSendFile
    },
    /**
     * 送信可能か
     * @return {Boolean}
     */
    permissionSend() {
      if (this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_TEXT) {
        return this.permissionSendMessageInput && this.fastchatSendMessage.messageText.length > 0 && this.validFastchatSendMessageForm
      } else if (this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_IMAGE || this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_VIDEO || this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_FILE) {
        return this.permissionSendMessageInput && this.uploadedSendFileContentId != null
      }
      return false
    },
    /**
     * サジェストが可能か
     * @return {Boolean}
     */
    permissionSuggestion() {
      if (!this.$config['_testMode'] && (!this.useSuggestion || !this.permissionSend)) {
        return false
      }
      const suggestTarget = this.fastchatSendMessage.messageText
      if (suggestTarget.trim().length === 0 || suggestTarget.indexOf('\n') > -1 || suggestTarget.indexOf('\r') > -1) {
        return false
      }
      return true
    },
    /**
     * メニューボタンを表示するか
     * @return {Boolean}
     */
    isShowMenuButton() {
      return (this.$config['sendImageFileFlg'] || this.$config['sendVideoFileFlg'] || this.$config['sendFileFlg'])
    },
    /**
     * 送信メッセージテキスト入力フォームを表示するか
     * @return {Boolean}
     */
    isShowSendTextMessageInputForm() {
      return this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_TEXT || this.uploadingSendFile
    },
    /**
     * 送信ファイルを表示するか
     * @return {Boolean}
     */
    isShowUploadedSendFile() {
      return (this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_IMAGE || this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_VIDEO || this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_FILE) && !this.uploadingSendFile
    },
    /**
     * メニュー実行が可能か
     * @return {Boolean}
     */
    permissionMenu() {
      return this.permissionSendMessageInput && this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_TEXT
    },
    /**
     * 送信画像プレビューを表示するか
     * @return {Boolean}
     */
    isShowImagePreview() {
      return this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_IMAGE
    },
    /**
     * XSRF-TOKEN
     * @return {string}
     */
    xsrfTocken() {
      return VueCookie.get('XSRF-TOKEN')
    }
  },
  methods: {
    /**
     * メッセージ送信情報フォームの入力チェック
     * @param  {Function} callback [description]
     */
    validateFastchatSendMessageForm(callback) {
      if (this.$refs['fastchatSendMessageForm']) {
        this.$refs['fastchatSendMessageForm'].validate((valid) => {
          callback(valid)
        })
      }
    },
    /**
     * 送信処理
     */
    send() {
      if (!this.permissionSend) {
        return
      }
      if (this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_TEXT) {
        this.$emit('sendMessage', {
          messageText: this.fastchatSendMessage.messageText.trim()
        })
      } else if (this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_IMAGE || this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_VIDEO || this.sendMessageType === MessageInfoConst.MESSAGE_TYPE_FILE) {
        this.$emit('sendMessage', {
          tempMessageAttachCid: this.uploadedSendFileContentId,
          snsMessageType: this.sendMessageType
        }, ChatMessageConst.MESSAGE_EVENT_TYPE_SEND_FILE)
      }
    },
    /**
     * 送信メッセージ情報フォームをクリアする
     */
    clearSendMessageForm() {
      this.suggestList_ = []
      this.determiningSuggestTargetKeyword = false
      this.$refs['suggestAutocomplete'].close()
      this.$refs['fastchatSendMessageForm'].resetFields()
      this.resetSendMessageType()
    },
    /**
     * 送信制限文字列が入力されているかチェック
     */
    validateWrongPatternList(rule, value, callback) {
      ValidateUtil.validateWrongPatternSettingList(rule, value, this.receptionMode, callback)
    },

    /**
     * サジェストリストを表示する
     * @param  {[Array]} suggestList
     */
    showSuggestList(suggestList) {
      if (!this.permissionSuggestion) {
        return
      }
      this.suggestList_ = suggestList.map(function (item) {
        return {
          value: item
        }
      })
      this.$refs['suggestAutocomplete'].handleFocus()
    },
    /**
     * サジェストフェッチ処理
     * @param  {[String]}   queryString
     * @param  {Function} cb
     */
    suggestFetchFunc(queryString, cb) {
      const suggestList_ = this.suggestList_
      this.suggestList_ = null
      cb(suggestList_)
      setTimeout(_ => {
        if (this.$refs['suggestAutocomplete'].popperElm != null) {
          this.$el.appendChild(this.$refs['suggestAutocomplete'].popperElm)
        }
      }, 0)
    },
    /**
     * サジェスト選択処理
     * @param  {[Object]} item
     */
    suggestAutocompleteSelectHandler(item) {
      if (!this.permissionSend) {
        return
      }
      this.$emit('sendMessage', {
        messageText: item.value
      })
    },
    /**
     * メニュー処理
     */
    doMenu(command) {
      if (command === 'uploadSendImageFile') {
        this.sendFileUploaderAccept = this.$config['sendImageFileExtension']
        this.sendFileUploaderAction = this.$config['serviceServer'] + '/uploadTempMessageAttachImage'
      } else if (command === 'uploadSendVideoFile') {
        this.sendFileUploaderAccept = this.$config['sendVideoFileExtension']
        this.sendFileUploaderAction = this.$config['serviceServer'] + '/uploadTempMessageAttachVideo'
      } else if (command === 'uploadSendFile') {
        this.sendFileUploaderAccept = this.$config['sendFileExtension']
        this.sendFileUploaderAction = this.$config['serviceServer'] + '/uploadTempMessageAttachFile'
      }
      // sendFileUploaderAccept、sendFileUploaderAction が即時反映されないため遅延実行
      setTimeout(_ => {
        this.$refs['uploadSendFileButton'].$el.click()
      }, 16)
    },
    /**
     * ファイル送信をキャンセルする
     */
    cancelSendFile() {
      this.resetSendMessageType()
    },
    /**
     * 送信モードをリセットする
     */
    resetSendMessageType() {
      this.$refs['sendFileUploader'].handleRemove()
      this.sendMessageType = MessageInfoConst.MESSAGE_TYPE_TEXT
      this.uploadingSendFile = false
      this.sendFileUploaderAccept = ''
      this.sendFileUploaderAction = ''
      this.uploadedSendFileUrl = ''
      this.uploadedSendFileName = ''
      this.uploadedSendFileContentId = null
    },
    /**
     * 送信ファイルアップっロード前処理
     */
    uploadSendFileBeforeUploadHandler(file) {
      const result = this.validateUploadFile(file)
      if (result) {
        this.uploadingSendFile = true
        if (this.sendFileUploaderAction === this.$config['serviceServer'] + '/uploadTempMessageAttachImage') {
          this.sendMessageType = MessageInfoConst.MESSAGE_TYPE_IMAGE
        } else if (this.sendFileUploaderAction === this.$config['serviceServer'] + '/uploadTempMessageAttachVideo') {
          this.sendMessageType = MessageInfoConst.MESSAGE_TYPE_VIDEO
        } else if (this.sendFileUploaderAction === this.$config['serviceServer'] + '/uploadTempMessageAttachFile') {
          this.sendMessageType = MessageInfoConst.MESSAGE_TYPE_FILE
        }
      }
      return result
    },
    /**
     * 送信ファイルのチェックを行います
     */
    validateUploadFile(file) {
      if (!StringUtil.endWithSuffixListCsv(file.name, this.sendFileUploaderAccept, true, true)) {
        DialogUtil.showInfoDialog(this.$t('{acceptFileExtension} のいずれかのファイルを選択してください。', {
          acceptFileExtension: this.sendFileUploaderAccept
        }))
        return false
      }
      const sendFileMaxSize = this.$config['sendFileMaxSize']
      if (file.size > sendFileMaxSize * 1048576) {
        DialogUtil.showInfoDialog(this.$t('{sendFileMaxSize}MB以下のファイルを選択してください。', {
          sendFileMaxSize: sendFileMaxSize
        }))
        return false
      }
      const sendFileNameMaxByteLength = this.$config['sendFileNameMaxByteLength']
      if (StringUtil.getByteLength(file.name) > 512) {
        DialogUtil.showInfoDialog(this.$t('ファイル名が{sendFileNameMaxByteLength}バイト以下のファイルを選択してください。', {
          sendFileNameMaxByteLength: sendFileNameMaxByteLength
        }))
        return false
      }
      return true
    },
    /**
     * 送信ファイルアップっロード成功処理
     */
    uploadSendFileSuccessHandler(response, file) {
      this.uploadedSendFileContentId = response
      this.uploadedSendFileUrl = file.url
      this.uploadedSendFileName = file.name
      this.uploadingSendFile = false
    },
    /**
     * 送信ファイルアップっロード失敗処理
     */
    uploadSendFileErrorHandler() {
      DialogUtil.showInfoDialog(this.$t('ファイルのアップロードに失敗しました。'))
      this.resetSendMessageType()
    }
  }
}
</script>

<style scoped>
.fc-send-message-form {
  position: relative;
}

.main-area {
  padding: 10px;
}

.menu-area {
  display: flex;
  align-items: center;
}

.menu-button {
  padding: 12px
}

.send-message-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item.is-error {
  margin-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/FcSendMessageForm.vue